import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('SellerPrincipal', SellerPrincipalData);

    SellerPrincipalData.$inject = ['$translate'];

    /* @ngInject */
    function SellerPrincipalData($translate) {
        SellerPrincipal.prototype = {
            build: build,
            getCountryLabelOfPrincipal: getCountryLabelOfPrincipal,
            getPrincipalTypeInvitation: getPrincipalTypeInvitation,
        };

        function SellerPrincipal(sellerPrincipalData) {
            this.build(sellerPrincipalData);
        }

        return SellerPrincipal;

        function build(sellerPrincipalData) {
            this.principalId = sellerPrincipalData.principalId || null;
            this.principalName = sellerPrincipalData.principalName || null;
            this.principalEid = sellerPrincipalData.principalEid || null;
            this.principalCountry = sellerPrincipalData.principalCountryCode || null;
            this.myInvoiceEnabled = sellerPrincipalData.myInvoiceEnabled || false;
            this.principalMyInvoiceEnabled = sellerPrincipalData.principalMyInvoiceEnabled || false;
            this.typeInvitation = sellerPrincipalData.typeInvitation || null;
            this.acceptation = sellerPrincipalData.ackDate || null;
        }

        /**
         * Fournit le libellé du pays du donneur d'ordres.
         */
        function getCountryLabelOfPrincipal() {
            if (this.principalCountry) {
                return $translate.instant('country.' + angular.lowercase(this.principalCountry));
            }
            return '';
        }

        function getPrincipalTypeInvitation() {
            if (this.typeInvitation) {
                return $translate.instant('kiss_invited_entity.type.' + angular.lowercase(this.typeInvitation));
            }
            return '';
        }
    }
})();
